import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  questions: {
    fontFamily: Theme.typography.base.regular,
    display: 'flex',
    justifyContent: 'center',
  },
  questionSectionWrapper: {
    width: '1080px',
    display: 'flex',
    flexDirection: 'column',
  },
  questionText: {
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'flex-start',
    '& span': {
      lineHeight: '150%',
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[6.5],
      color: Theme.palette.gray[800],
      [Theme.breakpoints.up('lg')]: {
        lineHeight: '150%',
        fontSize: Theme.typography.size[7],
      },
    },
    '& p': {
      marginTop: '8px',
      lineHeight: '150%',
      margin: '0',
      fontSize: Theme.typography.size[3],
      marginBottom: '30px',
      color: Theme.palette.gray[750],
      '&:last-child': {
        marginTop: '0',
        marginBottom: '0',
      },
      '& a': {
        fontFamily: Theme.typography.base.semiBold,
      },
      [Theme.breakpoints.down('lg')]: {
        lineHeight: '150%',
        fontSize: Theme.typography.size[2],
      },
      [Theme.breakpoints.down('md')]: {
        marginBottom: '20px',
      },
      [Theme.breakpoints.down('sm')]: {
        marginBottom: '23px',
      },
    },
    '& a': {
      display: 'inline',
      cursor: 'pointer',
      color: Theme.palette.primary.light,
    },
  },
  questionsCel: {
    display: 'flex',
    color: Theme.palette.gray[800],
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[6],
    [Theme.breakpoints.up('lg')]: {
      fontSize: Theme.typography.size[7],
    },
    '& p': {
      margin: 0,
    },
    '& a': {
      color: Theme.palette.primary.light,
      cursor: 'pointer',
      display: 'inline',
      fontFamily: Theme.typography.base.regular,
      '&::after': {
        content: '"."',
        color: Theme.palette.gray[800],
        position: 'relative',
      },
    },
  },
}));

export default useStyles;
